angular.module("Main").factory("SessionCache", [function () {
    let session = {};

    return {
        get: get,
        set: set
    };

    function get() {
        return session;

    }

    function set(_session) {
        session = _session;
    }
}]);